import { Component, type ErrorInfo, type ReactNode } from 'react';

export class AppErrorBoundary extends Component<{ children: ReactNode }, { error: Error | null }> {
  state: { error: Error | null } = { error: null };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('[yxmpd-web]', error, info.componentStack);
  }

  async resetApplication() {
    if ('caches' in window) {
      const keys = await caches.keys();
      await Promise.all(keys.filter((key) => key.startsWith('yxmpd-web-')).map((key) => caches.delete(key)));
    }
    if ('serviceWorker' in navigator) {
      const registrations = await navigator.serviceWorker.getRegistrations();
      await Promise.all(registrations.map((registration) => registration.unregister()));
    }
    window.location.reload();
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <main className="app-error-page">
        <img src="/logo.png" alt="伊小满拼豆" />
        <p className="eyebrow">页面没有正常打开</p>
        <h1>先别着急，图纸还在</h1>
        <p>先试试重新载入。如果还是空白，再清理旧版缓存。本地图纸不会因为这个操作被删除。</p>
        <div><button type="button" className="primary-button" onClick={() => window.location.reload()}>重新载入</button><button type="button" className="secondary-button" onClick={() => this.resetApplication()}>清理缓存并重开</button></div>
        <small>{this.state.error.message}</small>
      </main>
    );
  }
}
